// extracted by mini-css-extract-plugin
export default {"confirmRemoveLicenceDialog":"ConfirmRemoveUserFacadeLicence_confirmRemoveLicenceDialog__kotk1","buttonGroup":"ConfirmRemoveUserFacadeLicence_buttonGroup__PoT7n"};